import { activeRuleset } from "@/tax/rulesets";

/**
 * Ruleset stamp — small footer badge stating which ATO ruleset is in
 * force and when it was last reviewed. Used on any screen or PDF where
 * we surface tax numbers, so tradies (and their accountants) can see
 * at a glance which rules produced the figures.
 *
 * Keeps the reference authoritative: reads `activeRuleset` from the
 * versioned registry. When the ruleset bumps, this updates everywhere.
 */
export default function RulesetStamp({
  variant = "default",
  className = "",
}: {
  variant?: "default" | "muted" | "inline";
  className?: string;
}) {
  const r = activeRuleset;
  const reviewedDate = new Date(r.lastReviewed).toLocaleDateString("en-AU", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });

  const base = "inline-flex items-center gap-1.5 text-[10px] font-heading tracking-wider";
  const styleByVariant: Record<string, string> = {
    default: "text-white/40",
    muted: "text-white/25",
    inline: "text-white/50",
  };

  return (
    <span
      data-testid="ruleset-stamp"
      className={`${base} ${styleByVariant[variant]} ${className}`}
    >
      <span
        aria-hidden="true"
        className="w-1 h-1 rounded-full bg-current opacity-60"
      />
      ATO RULESET {r.version} · AS AT {reviewedDate.toUpperCase()}
    </span>
  );
}
